export default __webpack_public_path__ + "static/media/right-top.aec93e2c.png";